export default __webpack_public_path__ + "static/media/pptx.8e6ebc35.svg";